// import React, { useState, useEffect } from "react";
// import "../css-coding/service.css";

// const services = [
//   {
//     id: 1,
//     title: "Video Editing",
//     content:
//       "We’ll take care of turning your raw clips into high quality, storytelling content that captures attention and drives results.",
//   },
//   {
//     id: 2,
//     title: "Personal Branding",
//     content:
//       "We handle everything from ideation to execution, crafting content that builds consistency, community, and brand credibility.",
//   },
//   {
//     id: 3,
//     title: "Social Media Managing",
//     content:
//       "We’ll manage your Instagram and YouTube with bio optimization, content scheduling, and engagement strategies that convert.",
//   },
//   {
//     id: 4,
//     title: "Graphic Designing",
//     content:
//       "We design with intent, ensuring every visual delivers clarity, creativity, and a consistent brand experience.",
//   },
//   {
//     id: 5,
//     title: "Web Development",
//     content:
//       "We’ll take care of building a visually stunning, high-performing website that’s optimized for both users and conversions.",
//   },

//   {
//     id: 6,
//     title: "Shooting",
//     content:
//       "We handle personal and commercial shoots, delivering cinematic frames that showcase your brand’s personality and power.",
//   },

//   {
//     id: 7,
//     title: "Content Writing",
//     content:
//       "We create compelling, high-quality content that engages your audience, builds authority, and converts readers into customers. From blog posts and articles to website copy and case studies, we craft every word to deliver results and elevate your business.",
//   },
//   {
//     id: 8,
//     title: "Search Engine Optimization",
//     content:
//       "We implement tailored strategies to enhance your website's visibility, attract qualified traffic, and convert visitors into customers. Let us help you get found online and achieve sustainable business growth.",
//   },
//   {
//     id: 9,
//     title: "Meta & Google Ads",
//     content:
//       "We create and optimize campaigns to drive traffic and boost ROI, ensuring your message reaches the right audience for significant business growth.",
//   },
// ];

// const Services = () => {
//   const [activeId, setActiveId] = useState(1);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   if (isMobile) {
//     // Mobile view: all expanded with number and title on top, content below
//     return (
//       <div className="services-container">
//         <h2 className="heading">
//           This is how we help ambitious companies succeed.
//         </h2>
//         <ul className="services-list mobile-list">
//           {services.map((service) => (
//             <li key={service.id} className="service-item mobile-expanded mobile-shadow-box">
//               <div className="mobile-header">
//                 <span className="service-number">{`0${service.id}`}</span>
//                 <span className="service-title">{service.title}</span>
//               </div>
//               <p className="mobile-content">{service.content}</p>
//               <hr style={{ border: "none", height: "1px", backgroundColor: "#ccc", width: "375px", marginTop: "20px", marginLeft: "-30px", }} />
//             </li>
//           ))}
//         </ul>
//       </div>
//     );
//   }

//   // Desktop view with clickable active item
//   return (
//     <div className="services-container">
//       <h2 className="heading">
//         This is how we help ambitious companies <br></br>succeed.
//       </h2>
//       <ul className="services-list">
//         {services.map((service) => (
//           <li
//             key={service.id}
//             className={`service-item ${activeId === service.id ? "active" : ""}`}
//             // onClick={() => setActiveId(service.id)}
//              onMouseEnter={() => setActiveId(service.id)}
//           >
//             {activeId === service.id ? (
//               <div className={`active-bar-wrapper ${activeId === service.id ? "open" : ""}`}>
//               <div className="active-bar">
//                 <span className="active-number">{`0${service.id}`}</span>
//                 <span className="active-title">{service.title}</span>
//                 <span className="active-content">{service.content}</span>
//               </div>
//               </div>
//             ) : (
//               <div className="service-header">
//                 <span className="service-number">{`0${service.id}`}</span>
//                 <span className="service-title">{service.title}</span>
//                 <span className="plus-icon">+</span>
//               </div>
//             )}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default Services;



import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../css-coding/service.css";

const services = [
  {
    id: 1,
    title: "Video Editing",
    content:
      "We’ll take care of turning your raw clips into high quality, storytelling content that captures attention and drives results.",
  },
  {
    id: 2,
    title: "Personal Branding",
    content:
      "We handle everything from ideation to execution, crafting content that builds consistency, community, and brand credibility.",
  },
  {
    id: 3,
    title: "Social Media Managing",
    content:
      "We’ll manage your Instagram and YouTube with bio optimization, content scheduling, and engagement strategies that convert.",
  },
  {
    id: 4,
    title: "Graphic Designing",
    content:
      "We design with intent, ensuring every visual delivers clarity, creativity, and a consistent brand experience.",
  },
  {
    id: 5,
    title: "Web Development",
    content:
      "We’ll take care of building a visually stunning, high-performing website that’s optimized for both users and conversions.",
  },

  {
    id: 6,
    title: "Shooting",
    content:
      "We handle personal and commercial shoots, delivering cinematic frames that showcase your brand’s personality and power.",
  },

  {
    id: 7,
    title: "Content Writing",
    content:
      "We create compelling, high-quality content that engages your audience, builds authority, and converts readers into customers. From blog posts and articles to website copy and case studies, we craft every word to deliver results and elevate your business.",
  },
  {
    id: 8,
    title: "Search Engine Optimization",
    content:
      "We implement tailored strategies to enhance your website's visibility, attract qualified traffic, and convert visitors into customers. Let us help you get found online and achieve sustainable business growth.",
  },
  {
    id: 9,
    title: "Meta & Google Ads",
    content:
      "We create and optimize campaigns to drive traffic and boost ROI, ensuring your message reaches the right audience for significant business growth.",
  },
];

const Services = () => {
  const [activeId, setActiveId] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const getXOffset = () => {
  if (window.innerWidth >= 1440) return -40;
  if (window.innerWidth >= 1350) return -8;
  if (window.innerWidth >= 992) return -2;  
  return 2;// fallback
};


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ---------------- MOBILE ---------------- */
  if (isMobile) {
    return (
      <div className="services-container">
        <h2 className="heading">
          This is how we help ambitious companies succeed.
        </h2>
        <ul className="services-list mobile-list">
          {services.map((service) => (
            <li key={service.id} className="service-item">
              <div className="mobile-header">
                <span className="service-number">{`0${service.id}`}</span>
                <span className="service-title">{service.title}</span>
              </div>
              <p className="mobile-content">{service.content}</p>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  /* ---------------- DESKTOP ---------------- */
  return (
    <div className="services-container">
      <h2 className="heading">
        This is how we help ambitious companies <br /> succeed.
      </h2>

      <ul className="services-list">
        {services.map((service) => {
          const isActive = activeId === service.id;

          return (
            <li
              key={service.id}
              className={`service-item ${isActive ? "active" : ""}`}
              onMouseEnter={() => setActiveId(service.id)}
            >
              {isActive ? (
                <div className="active-bar-wrapper open">
                  <div className="active-bar">
                   <motion.span
                      key={`num-${service.id}`}
                      className="active-number"
                      initial={{ opacity: 0, x: -22 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -6 }}
                      transition={{ duration: 0.3, ease: "easeOut" }}
                    >
                      {`0${service.id}`}
                    </motion.span>

                    <motion.span
                      key={`title-${service.id}`}
                      className="active-title"
                      initial={{ opacity: 0, x: -26 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -8 }}
                      transition={{ duration: 0.32, ease: "easeOut" }}
                    >
                      {service.title}
                    </motion.span>

                    {/* 🔥 Framer Motion ONLY here */}
                    <AnimatePresence mode="wait">
                      <motion.span
                        key={service.id}
                        className="active-content"
                        initial={{ opacity: 0, x: 32 }}
                        animate={{ opacity: 1, x: getXOffset() }}
                        exit={{ opacity: 0, x: -8 }}
                        transition={{ duration: 0.34, ease: "easeOut" }}
                      >
                        {service.content}
                      </motion.span>
                    </AnimatePresence>
                  </div>
                </div>
              ) : (
                <div className="service-header">
                  <span className="service-number">{`0${service.id}`}</span>
                  <span className="service-title">{service.title}</span>
                  <span className="plus-icon">+</span>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Services;